var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventoryandcontrolofenterpriseassets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "71px",
    viewBox: "0 0 72.0 71.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561,0 L1561,1080 L0,1080 L0,0 L1561,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-48.3870968%",
    y: "-49.1803279%",
    filterUnits: "userSpaceOnUse",
    width: "164.516129%",
    height: "165.57377%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3799338,0.000529895883 L30.5691449,0.00362398408 C31.9099594,0.0738988139 32.9604231,1.22891376 32.9604231,2.63256357 L32.9604231,2.93288884 L34.2052981,2.93288884 C35.139008,2.93288884 35.8991892,3.69114745 35.8991892,4.62288672 L35.8991892,6.63101671 L39.7853178,6.63106716 C41.0062324,6.63106716 42,7.6223991 42,8.84078774 L42,32.3114145 C42,33.5298032 41.0066129,34.5211351 39.7856984,34.5211351 L29.5586522,34.5211351 L29.5586522,38.7724221 C29.5586522,39.9999475 28.5576678,40.9988609 27.3272081,40.9988609 L12.2126078,40.9988609 L4.3722923,41 C3.14105333,41 2.1392898,39.9999202 2.1392898,38.7712284 L2.1392898,29.6891544 L0.999802054,29.6891544 C0.686299257,29.6891544 0.397136829,29.5467774 0.206524168,29.2984632 C0.0159105321,29.0501588 -0.0464871119,28.7346414 0.0349338121,28.4327901 L2.0669992,20.8763505 C2.18419141,20.4412297 2.58102028,20.1378621 3.03225704,20.1378621 L12.188288,20.1378621 C12.1947554,20.1378621 12.2008433,20.135584 12.2073113,20.135584 L18.8670664,20.135584 L18.8670664,8.84106777 C18.8670664,7.62229033 19.8604535,6.6309584 21.0817576,6.6309584 L24.9697884,6.6309584 L24.9697884,4.6228284 C24.9697884,3.69105997 25.7300086,2.93283052 26.6636795,2.93283052 L27.9085545,2.93283052 L27.9085545,2.52087228 C27.9085545,1.83289822 28.195428,1.16621072 28.6957448,0.692365916 C29.2032985,0.211688024 29.8725077,-0.0332056643 30.5691449,0.00362398408 Z M11.6618686,24.8101244 L10.5485816,28.9502158 L10.4580292,29.2858564 C10.3941053,29.5239161 10.1776133,29.6890765 9.93107334,29.6890765 L6.45504643,29.6890765 L6.45504643,33.290783 C6.45504643,33.5914971 6.21078561,33.8352526 5.90944813,33.8352526 C5.60773078,33.8352526 5.36384982,33.5914971 5.36384982,33.290783 L5.36384982,29.6890765 L3.23019577,29.6890765 L3.22981533,38.7714422 C3.22981533,39.3998624 3.74235592,39.9112941 4.37203029,39.9112941 L11.6618686,39.9109509 L11.6618686,24.8101244 Z M12.7536304,23.3279984 L12.7536304,39.9101367 L27.3276583,39.9105165 C27.9565729,39.9105165 28.4679252,39.4002221 28.4679252,38.7726086 L28.4674496,34.5213629 L21.0821586,34.5213629 C19.8608545,34.5213629 18.8674674,33.530031 18.8674674,32.3116424 L18.8674674,29.6880487 L15.8510732,29.6880487 C15.6307826,29.6880487 15.4321724,29.5559262 15.3473278,29.3524111 L15.263244,29.1492847 C15.2510689,29.1287826 15.2404159,29.1075203 15.2309041,29.085878 L12.7536304,23.3279984 Z M25.5120167,7.71968726 L21.0825368,7.71968726 C20.4631382,7.71968726 19.9586331,8.22275007 19.9586331,8.84087697 L19.9586331,32.3115038 C19.9586331,32.9299903 20.4631285,33.4326935 21.0825368,33.4326935 L39.7853694,33.4326935 C40.4051381,33.4326935 40.9088835,32.9296307 40.9088835,32.3115038 L40.90948,8.84087697 C40.90948,8.22276951 40.4053743,7.71968726 39.7859659,7.71968726 L35.3580445,7.71968726 L25.5140617,7.72006692 Z M11.4959959,21.2267428 L3.10280515,21.2267428 L1.1202375,28.6009344 L5.90632015,28.6003649 C5.91183697,28.5997953 5.9137393,28.6009344 5.91602207,28.6009344 L9.51302033,28.6009344 L11.4959959,21.2267428 Z M18.8670664,21.2244405 L13.0347829,21.2244405 L16.2056542,28.5967853 L18.8670664,28.5998228 L18.8670664,21.2244405 Z M30.5121462,1.09064827 C30.1148887,1.0720444 29.735553,1.20872554 29.4467802,1.48171847 C29.1579976,1.75475999 28.999342,2.1241937 28.999342,2.52058068 L28.999342,3.47699876 C28.999342,3.77771282 28.7550812,4.02146831 28.4537437,4.02146831 L26.663621,4.02146831 C26.3310862,4.02146831 26.0605759,4.29103984 26.0605759,4.62288672 L26.0605759,6.63094809 L34.80809,6.63132775 L34.80809,4.62319776 C34.80809,4.29172995 34.5375798,4.02177935 34.2050449,4.02177935 L32.4149222,4.02177935 C32.1132049,4.02177935 31.8693239,3.77802386 31.8693239,3.4773098 L31.8693239,2.63251497 C31.8693239,1.82153566 31.2605322,1.13013534 30.5121462,1.09064827 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1328933,0 C17.4342308,0 17.6784916,0.243765209 17.6784916,0.544090477 L17.6784916,21.9025844 C17.6784916,22.2032985 17.4342308,22.447054 17.1328933,22.447054 L0.545598306,22.4474336 C0.243880962,22.4474336 0,22.2036781 0,21.9029641 L0,0.544470136 C0,0.243756072 0.244260824,0 0.545598306,0 Z M16.587295,1.08862865 L1.09185894,1.08862865 L1.09185894,21.3584945 L16.587295,21.3584945 L16.587295,1.08862865 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.545598306,0 C0.846935788,0 1.09081607,0.243755489 1.09119661,0.544469553 L1.09119661,1.08893911 C1.09119661,1.38965317 0.846935788,1.63340866 0.545598306,1.63340866 C0.243880962,1.63340866 0,1.38965317 0,1.08893911 L0,0.544469553 C0,0.243755489 0.244260824,0 0.545598306,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88685397,0 C7.18857131,0 7.43245228,0.243755489 7.43245228,0.544469553 C7.43245228,0.845183618 7.18819145,1.08893911 6.88685397,1.08893911 L0.545598306,1.08893911 C0.244260824,1.08893911 0,0.845183618 0,0.544469553 C0,0.243755489 0.244260824,0 0.545598306,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2125673,0 C1.51428465,0 1.75816561,0.243755489 1.75816561,0.544469553 C1.75816561,0.845183618 1.51390478,1.08893911 1.2125673,1.08893911 L0.545598306,1.08893911 C0.244260824,1.08893911 0,0.845183618 0,0.544469553 C0,0.243755489 0.244260824,0 0.545598306,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88685397,0 C7.18857131,0 7.43245228,0.243755489 7.43245228,0.544469553 C7.43245228,0.845183618 7.18819145,1.08893969 6.88685397,1.08893969 L0.545598306,1.08893969 C0.244260824,1.08893969 0,0.845174481 0,0.544849212 C0,0.244135148 0.244260824,0.000379659039 0.545598306,0.000379659039 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2125673,0 C1.51428465,0 1.75816561,0.243755489 1.75816561,0.544469553 C1.75816561,0.845183618 1.51390478,1.08893911 1.2125673,1.08893911 L0.545598306,1.08893911 C0.244260824,1.08893911 0,0.845183618 0,0.544469553 C0,0.243755489 0.244260824,0 0.545598306,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88685397,0 C7.18857131,0 7.43245228,0.243755489 7.43245228,0.544469553 C7.43245228,0.845183618 7.18819145,1.08893911 6.88685397,1.08893911 L0.545598306,1.08893911 C0.244260824,1.08893911 0,0.845183618 0,0.544469553 C0,0.243755489 0.244260824,0 0.545598306,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-294.0 -931.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.0 946.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "6.9388939e-18,1.73472348e-18 42,1.73472348e-18 42,41 6.9388939e-18,41 6.9388939e-18,1.73472348e-18",
    stroke: "none",
    fill: "#55BAB0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.5936358989521 9.352586305966557)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.6784916,0 17.6784916,22.4474336 0,22.4474336 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.363800534463602 35.46896868075548)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.09119661,0 1.09119661,1.63340866 0,1.63340866 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.46523696097374 14.794444212058998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.43245228,0 7.43245228,1.08893911 0,1.08893911 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.96856115478555 14.794444212058998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.75816561,0 1.75816561,1.08893911 0,1.08893911 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.46523696097374 18.28582995009951)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.43245228,0 7.43245228,1.08893969 0,1.08893969 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.96856115478555 18.28582995009951)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.75816561,0 1.75816561,1.08893911 0,1.08893911 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.46523696097374 21.77721568814001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.43245228,0 7.43245228,1.08893969 0,1.08893969 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.96856115478555 21.77721568814001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.75816561,0 1.75816561,1.08893911 0,1.08893911 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.46523696097374 25.26957341552853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.43245228,0 7.43245228,1.08893911 0,1.08893911 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.96856115478555 25.26957341552853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.75816561,0 1.75816561,1.08893911 0,1.08893911 0,0",
    stroke: "none",
    fill: "#55BAB0"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryandcontrolofenterpriseassets);
export default __webpack_public_path__ + "static/media/inventoryandcontrolofenterpriseassets.6034c7eb12ece4413381109dc5006084.svg";
export { ForwardRef as ReactComponent };